/*
const stickyElement = document.querySelector(".header-group-wrapper");
let lastScrollTop = stickyElement.offsetHeight;
window.addEventListener("scroll", function () {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    stickyElement.classList.add("show_fixed");
    stickyElement.classList.remove("show-fixed-visible");
  } else {
    if (scrollTop > 0) {
      stickyElement.classList.add("show_fixed", "show-fixed-visible");
    } else {
      stickyElement.classList.remove("show_fixed", "show-fixed-visible");
    }
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});*/
document.addEventListener("DOMContentLoaded", function () {
    (function () {
        var headerWrapper = document.querySelector(".header-group-wrapper");

        if (headerWrapper) {
            var prevScrollPos = 0;

            // Check if the header does not have the "no-scroll" class
         
                // Add scroll event listener
                window.addEventListener("scroll", function () {
                    var currentScrollPos = window.scrollY,
                        headerHeight = headerWrapper.offsetHeight;

                    // Check if mobile navigation is not opening
          
                        if (currentScrollPos >= headerHeight) {
                            headerWrapper.classList.add("show_fixed");

                            var scrollDirection = window.pageYOffset || document.documentElement.scrollTop;

                            if (scrollDirection > prevScrollPos) {
                                headerWrapper.classList.remove("show-fixed-visible");
                                 
                            } else {
                               setTimeout(() => {
                                headerWrapper.classList.add(
                                    "site-header-wrapper--transition",
                                    "show-fixed-visible",
                                );
                              }, 100);
                            }
                            prevScrollPos = scrollDirection <= 0 ? 0 : scrollDirection;
                        } else if (currentScrollPos === 0) {
                          
                            headerWrapper.classList.remove(
                                "show-fixed-visible",
                                "show_fixed",
                                "site-header-wrapper--transition"
                            );
                        }
                    
                });
         

        
        
        }
    })();
});
